import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Button } from '@/components/button'
import {
  DashboardRow,
  DashboardContent,
  DashboardTitle,
  DashboardDescription
} from '@/components/settings'

const ConnectPad: React.FC<Nothing> = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const handleConnect = () => {
    history.push('/settings/payment-settings/pre-authorized-debit')
  }

  return (
    <DashboardRow>
      <DashboardContent>
        <DashboardTitle>
          {t('r.payment_settings.view.direct_debit.label', 'Direct Debit')}
        </DashboardTitle>
        <DashboardDescription>
          {t(
            'r.payment_settings.view.pad_description.text',
            'PAD is a convenient way to pay bills and make other payments automatically.'
          )}
        </DashboardDescription>
      </DashboardContent>
      <Button theme="primary" onClick={handleConnect}>
        {t('r.payment_settings.view.connect.button', 'Connect')}
      </Button>
    </DashboardRow>
  )
}

export default ConnectPad
